import type { SanityPageBuilderBenefitsBenefit, SanityPageBuilderBenefitsSection, SanityPageBuilderSection } from "@ouster/shared";
import { BenefitsBlockView } from "~/features/blocks/inventory/benefits";
import { BenefitView, type BenefitViewProps } from "~/features/blocks/inventory/benefits/benefit";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderBenefitsSection;
  };
};
type BenefitsViewItem = Omit<BenefitViewProps, "count" | "mode" | "theme"> & Pick<SanityPageBuilderBenefitsBenefit, "_key">;
export function SanityBenefitsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const items = sectionContent.benefits?.map<BenefitsViewItem>(benefit => ({
    _key: benefit._key,
    text: benefit.text,
    title: benefit.title
  })) ?? [];
  return <BenefitsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} items={items} mode={mode} renderItem={(item, _index, count) => <BenefitView count={count} mode={mode} text={item.text} theme={theme} title={item.title} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={theme} />;
}